/** "Minimum N required" hint text, or undefined when no minimum applies. */
export const getMinRequiredHint = (minItems?: number): string | undefined =>
  minItems && minItems > 0 ? `Minimum ${minItems} required` : undefined;
